import { trackMetricsEvent } from './trackMetricsEvent';

export type TrackOutputExportedOptions = {
  eventSource: string;
  app?: string;
  jobID?: string;
  batchID?: string;
  format?: string;
  fileCount?: number;
  outputDurationSeconds?: number;
};

/**
 * Fire-and-forget UI emit for Metrics `outputExported`.
 * Failures are ignored so download UX is never blocked by analytics.
 */
export function trackOutputExported({
  eventSource,
  app,
  jobID,
  batchID,
  format,
  fileCount,
  outputDurationSeconds,
}: TrackOutputExportedOptions): void {
  const properties: Record<string, unknown> = {};
  if (jobID) properties.jobID = jobID;
  if (batchID) properties.batchID = batchID;
  if (format) properties.format = format;
  if (fileCount !== undefined) properties.fileCount = fileCount;
  if (outputDurationSeconds !== undefined) {
    properties.outputDurationSeconds = outputDurationSeconds;
  }

  void trackMetricsEvent({
    eventName: 'outputExported',
    eventSource,
    ...(app ? { app } : {}),
    ...(Object.keys(properties).length > 0 ? { properties } : {}),
  });
}
